import React, { useCallback, useState } from 'react';
import { FieldValues, Path } from 'react-hook-form';
//
import { FormInputProps } from '../../componets/form/formInterfaces';
import { ImperativeHandleAccessedByParentComponent } from '../../componets/interfaces/formProps';
import FormComplete from '../../componets/form/formComplete';
import * as ImplEnum from '../../communs/enums/generic-enum';
import { Box, IconButton, Modal, Typography } from '@mui/material';
import { IconComponent, icons } from '../../componets/icons';
import { useAuth } from '../../context/AuthContext';
import { useHistory, useParams } from 'react-router-dom';
import { paths } from '../../config';
import FormCustomer from '../customer/customerForm';
import { useWindowSize } from '../../util/responsiveness';

const enumInstances = {
    howDidYouFindOptionsInstance: new ImplEnum.GenericEnum(
        ImplEnum.howDidYouFindOptions,
    ),
    yesOrNoOptionsInstance: new ImplEnum.GenericEnum(ImplEnum.yesOrNoOptions),
    typeNumberPhoneInstance: new ImplEnum.GenericEnum(ImplEnum.typeNumberPhone),
    statusOptionsInstance: new ImplEnum.GenericEnum(ImplEnum.statusOptions),
};

const howDidYouFindOptions =
    enumInstances.howDidYouFindOptionsInstance.optionsList();
const yesOrNoOptions = enumInstances.yesOrNoOptionsInstance.optionsList();

interface IFormInput extends FieldValues {
    description: string;
}

const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '1200px',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 2,
    borderRadius: '4px',
};

interface IModalCustomer {
    open: boolean;
    setOpen: (open: boolean) => void;
    width: any;
    setValue?: any;
    params?: {
        id: string;
    };
}

function ModalCustomer({
    open,
    setOpen,
    width,
    setValue,
    params,
}: IModalCustomer) {
    const refForm = React.useRef<any>(null);

    const settings = {
        pathRegister: paths.customerRegister,
        pathList: paths.customer,
        apiPath: 'customer',
        permissionAdmin: null,
        title: '',
        boxShadow: '0',
    };

    const handleClose = () => {
        setOpen(false);
    };

    const styleModal = {
        ...style,
    };

    if (width <= 800) {
        styleModal.width = '90%';
    }

    function callbackSuccessByModal(response: any) {
        setValue('customer', {
            id: response.data.id,
            name: response.data.name,
        });
        handleClose();
    }

    return (
        <div>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description">
                <Box sx={styleModal} component={'div'}>
                    <div className="header-modal-customer">
                        <Typography
                            id="modal-modal-title"
                            variant="h6"
                            component="h2">
                            Cliente
                        </Typography>
                        <IconButton onClick={handleClose}>
                            <IconComponent icon={icons.Close} />
                        </IconButton>
                    </div>
                    <FormCustomer
                        ref={refForm}
                        settings={settings}
                        actionByModal={true}
                        callbackSuccessByModal={callbackSuccessByModal}
                        params={params?.id ? params : undefined}
                    />
                </Box>
            </Modal>
        </div>
    );
}

const Form: React.FC<{ settings: any }> = props => {
    const params = useParams<'id' | any>();
    const history = useHistory();

    const { settings } = props;
    const { user } = useAuth();
    const [openModalCustomer, setOpenModalCustomer] = React.useState(false);
    const [customerId, setCustomerId] = React.useState('');
    const [width] = useWindowSize();

    const [consultationValueRef, setConsultationValueRef] = useState<number>();

    const refForm =
        React.useRef<ImperativeHandleAccessedByParentComponent<IFormInput>>(
            null,
        );

    const inputsForm = React.useMemo<FormInputProps<IFormInput>[]>(
        () => [
            {
                typeInput: 'autocomplete',
                name: 'customer',
                control: null,
                label: 'Nome do cliente',
                loadingAutocomplete: false,
                md: 6,
                xs: 12,
                rules: {
                    required: true,
                },
                messagesError: [
                    {
                        type: 'required',
                        message: 'O campo é obrigatório',
                    },
                ],
                query: (value: string) => `customer?name=${value}`,
                activeDebounce: true,
                actionsOnInput: [
                    {
                        action: () => {
                            setOpenModalCustomer(true);
                        },
                        iconProps: {
                            icon: icons.AddCircle,
                        },
                        textTooltip: 'Adicionar cliente',
                        additionalDataQa: 'Customer',
                    },
                    {
                        action: (): void => {
                            setOpenModalCustomer(true);
                            setCustomerId(getValues('customer')?.id);
                        },
                        iconProps: {
                            icon: icons.Archive,
                        },
                        textTooltip: 'Visualizar cliente',
                        additionalDataQa: 'ViewCustomer',
                    },
                ],
            },
            {
                typeInput: 'date',
                name: 'dateCustomerService',
                control: null,
                label: 'Data',
                setValue: null,
                md: 3,
                xs: 12,
                placeholder: 'dd/mm/aaaa hh:mm',
                rules: {
                    validate: (value: any) => {
                        if (value && String(value) === 'Invalid Date') {
                            return 'A data está em um formato inválido';
                        }
                    },
                },
            },
            {
                typeInput: 'autocomplete',
                name: 'newCustomer',
                control: null,
                label: 'Cliente novo?',
                loadingAutocomplete: false,
                setValue: null,
                options: yesOrNoOptions,
                md: 3,
                xs: 12,
                rules: {
                    validate: (value: any) => {
                        if (!value?.id) {
                            return 'O campo é obrigatório';
                        }
                    },
                },
                dto: data => {
                    const configResult = {
                        '0': false,
                        '1': true,
                    };

                    data.newCustomer =
                        configResult[data.newCustomer.id as '0' | '1'];
                    return data;
                },
                setData: data => {
                    let result = '0';
                    if (data.closedContract) {
                        result = '1';
                    }
                    return enumInstances.yesOrNoOptionsInstance.getObject(
                        result,
                    );
                },
            },

            {
                typeInput: 'text',
                name: 'subject',
                control: null,
                label: 'Assunto',
                loadingAutocomplete: false,
                md: 6,
                xs: 12,
            },

            {
                typeInput: 'autocomplete',
                name: 'closedContract',
                control: null,
                label: 'Fechou contrato?',
                loadingAutocomplete: false,
                setValue: null,
                options: yesOrNoOptions,
                md: 3,
                xs: 12,
                rules: {
                    validate: (value: any) => {
                        if (!value?.id) {
                            return 'O campo é obrigatório';
                        }
                    },
                },
                dto: data => {
                    const configResult = {
                        '0': false,
                        '1': true,
                    };

                    data.closedContract =
                        configResult[data.closedContract.id as '0' | '1'];
                    return data;
                },
                setData: data => {
                    let result = '0';
                    if (data.closedContract) {
                        result = '1';
                    }
                    return enumInstances.yesOrNoOptionsInstance.getObject(
                        result,
                    );
                },
            },
            {
                typeInput: 'autocomplete',
                name: 'howDidYouFind',
                control: null,
                label: 'Como nos conheceu',
                loadingAutocomplete: false,
                setValue: null,
                options: howDidYouFindOptions,
                md: 3,
                xs: 12,
                rules: {
                    validate: (value: any) => {
                        if (!value?.id) {
                            return 'O campo é obrigatório';
                        }
                    },
                },
                dto: data => {
                    data.howDidYouFind = data.howDidYouFind.id;
                    return data;
                },
                setData: data => {
                    return enumInstances.howDidYouFindOptionsInstance.getObject(
                        data.howDidYouFind,
                    );
                },
            },
            {
                typeInput: 'autocomplete',
                name: 'user',
                control: null,
                label: 'Advogado',
                setValue: null,
                md: 3,
                xs: 12,
                rules: {
                    required: true,
                },
                messagesError: [
                    {
                        type: 'required',
                        message: 'O campo Advogado(a) é obrigatório',
                    },
                ],
                query: (value: string) => `users?name=${value}`,
                activeDebounce: true,
            },
            {
                typeInput: 'number',
                name: 'consultationValue',
                control: null,
                label: 'Valor de honorários',
                md: 3,
                xs: 12,
                decimalScale: 2,
                rules: {
                    validate: (value: number) => {
                        if (value && value < 0) {
                            return 'O campo não pode ser menor que zero';
                        }
                    },
                },
            },
            {
                typeInput: 'date',
                name: 'dateNextContact',
                control: null,
                label: 'Data do próximo contato',
                setValue: null,
                md: 3,
                xs: 12,
                placeholder: 'dd/mm/aaaa hh:mm',
                rules: {
                    validate: (value: any) => {
                        if (value && String(value) === 'Invalid Date') {
                            return 'A data está em um formato inválido';
                        }
                    },
                },
            },
            {
                typeInput: 'autocomplete',
                name: 'status',
                control: null,
                label: 'Status',
                loadingAutocomplete: false,
                setValue: null,
                options: enumInstances.statusOptionsInstance.optionsList(),
                md: 3,
                xs: 12,
                rules: {
                    validate: (value: any) => {
                        if (!value?.id) {
                            return 'O campo é obrigatório';
                        }
                    },
                },
                dto: data => {
                    data.status = data.status.id;
                    return data;
                },
                setData: data => {
                    return enumInstances.statusOptionsInstance.getObject(
                        data.status,
                    );
                },
            },
            {
                typeInput: 'text',
                name: 'observation',
                control: null,
                label: 'Observação',
                loadingAutocomplete: false,
                multiline: true,
                md: 12,
                xs: 12,
            },
            {
                typeInput: 'checkbox',
                name: 'generateInstallments',
                control: null,
                label: 'Gerar parcelas',
                md: 3,
                xs: 12,
            },
        ],
        [],
    );

    function callbackSuccess(response: any) {
        if (
            params?.id &&
            response.data?.consultationValue != consultationValueRef
        ) {
            response.data.generateInstallments = true;
        }
        if (
            response.data?.generateInstallments &&
            response.data?.consultationValue > 0 &&
            response.data?.additionalHonorarium?.id &&
            response.data?.user?.id
        ) {
            const redirect = Object.keys(paths).find(
                k => k === 'customerService',
            );
            history.push(
                `${paths.invoiceDetailRegister}/${
                    response.data.additionalHonorarium.id
                }/additionalHonorarium/${
                    refForm?.current?.watch('user')?.id
                }/${redirect}`,
            );
        } else {
            history.push(`${paths.customerService}?`);
        }
    }

    const defaultValues = React.useMemo<any>(() => {
        return {
            user: {
                id: user.sub,
                description: user.name,
            },
            generateInstallments: !params?.id,
        };
    }, [user, params]);

    const implSetValueData = useCallback((data: IFormInput) => {
        for (const input of inputsForm) {
            if (input.name === 'consultationValue') {
                setConsultationValueRef(
                    data[input.name as keyof IFormInput] as number,
                );
            }
            if (input.name == 'generateInstallments' && !params?.id) {
                refForm?.current?.setValue(
                    input.name as Path<IFormInput>,
                    true,
                );
                continue;
            }
            if (input?.setData) {
                refForm?.current?.setValue(
                    input.name as Path<IFormInput>,
                    input.setData(data),
                );
                continue;
            }

            refForm?.current?.setValue(
                input.name as Path<IFormInput>,
                data[input.name as keyof IFormInput],
            );
        }
    }, []);

    function setValue(key: any, value: any) {
        refForm?.current?.setValue(key, value);
    }

    function getValues(key: any) {
        return refForm?.current?.getValues(key);
    }

    return (
        <>
            <FormComplete
                defaultValues={defaultValues}
                inputsForm={inputsForm}
                ref={refForm}
                settings={settings}
                callbackSuccess={callbackSuccess}
                implSetValueData={implSetValueData}
            />
            <ModalCustomer
                open={openModalCustomer}
                setOpen={setOpenModalCustomer}
                width={width}
                setValue={setValue}
                params={customerId ? { id: customerId } : undefined}
            />
        </>
    );
};

export default Form;
